var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemThumbsUpCircleFilled = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M2 12C2 6.478 6.478 2 12 2s10 4.478 10 10-4.478 10-10 10S2 17.522 2 12m14.045 2.993-6.08.003v-4.573s.5-.336.788-.575c1.116-.926 2.048-2.852 2.048-2.852.376.001.61.165.716.262.107.098.277.306.224.605l-.225 1.256-.233 1.304h2.713c2.23 0 .05 4.57.05 4.57M7 14.996h2.01v-4.57H7z",
  clipRule: "evenodd"
})));
export default SvgGemThumbsUpCircleFilled;